import { render, staticRenderFns } from "./subsidiaries.vue?vue&type=template&id=ca32974c&scoped=true&"
import script from "./subsidiaries.vue?vue&type=script&lang=js&"
export * from "./subsidiaries.vue?vue&type=script&lang=js&"
import style0 from "./subsidiaries.vue?vue&type=style&index=0&id=ca32974c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca32974c",
  null
  
)

export default component.exports